var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-cascader", {
    ref: "cascader",
    attrs: {
      props: _vm.props,
      disabled: _vm.disabled,
      placeholder: _vm.placeholder,
    },
    on: { change: _vm.onChange },
    model: {
      value: _vm.selectValue,
      callback: function ($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }